module.exports = __webpack_public_path__ + "static/media/ThumbelinaWhite.5e052dc0.jpeg";